import { render, staticRenderFns } from "./MasterclassLandingPage.vue?vue&type=template&id=519d17ee&"
import script from "./MasterclassLandingPage.vue?vue&type=script&lang=js&"
export * from "./MasterclassLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports